import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const collapsibleContainerV3Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Collapsible Container element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'collapsibleContainer'>): void => {
    const collapsibleContainerProps = props;

    if (
      collapsibleContainerProps?.style?.header?.title &&
      !collapsibleContainerProps?.content?.header?.iconColor
    ) {
      const currentColor = collapsibleContainerProps.style.header.title.color1;
      collapsibleContainerProps.content = {
        ...collapsibleContainerProps.content,
        header: {
          ...collapsibleContainerProps.content?.header,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
